import type { OptionSheetOption } from '@frontend/api-types';
import { formatCurrencyWithCommasAndDecimal, isNil, type Currency } from '@frontend/duck-tape';
import { RenderHTML } from '../Primitives/Containers/RenderHTML';
import { XStack } from '../Primitives/Containers/Stacks/XStack';
import { YStack } from '../Primitives/Containers/Stacks/YStack';
import { Icon } from '../Primitives/Icon/Icon';
import { Modal } from '../Primitives/Modals/Modal';
import { Text } from '../Primitives/Texts/Text';

export type OptionDetailModalProps = {
  currency: MaybeUndefined<string>;
  onClose: () => void;
  option: OptionSheetOption | null;
};

export const OptionDetailModal = ({ currency, onClose, option }: OptionDetailModalProps) => (
  <Modal isOpen={!!option} onClose={onClose} padding="none" size="600px">
    {option ? (
      <>
        <div className="relative overflow-hidden bg-neutral-100" style={{ aspectRatio: '16/9' }}>
          {option.imageUrls?.[0] ? (
            <>
              <img
                alt=""
                // eslint-disable-next-line tailwindcss/no-custom-classname
                className="absolute inset-0 size-full scale-110 object-cover blur-xl"
                src={option.imageUrls[0]}
              />
              <img alt="" className="relative size-full object-contain" src={option.imageUrls[0]} />
            </>
          ) : null}
        </div>
        <YStack className="gap-md p-lg">
          <YStack className="gap-xs">
            {option.url ? (
              <XStack className="items-start gap-xs">
                <a
                  className="underline underline-offset-2 hover:opacity-80"
                  href={option.url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Text type="h3">{option.title}</Text>
                </a>
                <Icon className="mt-xs shrink-0" color="secondary" name="IconExternalLink" size={16} />
              </XStack>
            ) : (
              <Text type="h3">{option.title}</Text>
            )}
            {option.priceDisplay || !isNil(option.price) ? (
              <Text color="tertiary" type="h5">
                {option.priceDisplay || formatCurrencyWithCommasAndDecimal(option.price, currency as Currency)}
              </Text>
            ) : null}
          </YStack>
          <RenderHTML className="text-p-sm" html={option.description} />
        </YStack>
      </>
    ) : null}
  </Modal>
);
